import React, { Suspense, useContext } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { useIntl } from "react-intl";

import { isBrowser } from "../utils";
import { defaultLanguage } from "../i18n";
import LocalesContext from "../context/LocalesContext";

const LanguageSwitcher = () => {
  const languages = useStaticQuery(graphql`
    query GetLanguages {
      wp {
        languages {
          slug
          name
          homeUrl
          id
          locale
        }
      }
    }
  `);

  const langs = languages.wp.languages.map((lang) => {
    return {
      ...lang,
      homeUrl: lang.homeUrl.replace("/index.php", ""),
      icon: React.lazy(() => import(`../images/svg/${lang.slug}.svg`)),
    };
  });

  let CurrentFlag = null;

  if (isBrowser()) {
    CurrentFlag = React.lazy(() => import(`../images/svg/${intl.locale}.svg`));
  }

  const intl = useIntl();
  const localeData = useContext(LocalesContext);

  return (
    <div className="language-switcher-component">
      <span className="lsc__current-lang">
        {isBrowser() && (
          <Suspense fallback="...">
            <div className="language-switcher-component__label">Language</div>
            <div className="language-switcher-component__flag"><CurrentFlag width="16px" /></div>
          </Suspense>
        )}
      </span>

      <ul>
        {langs.map((lang) => {
          const locale = defaultLanguage === lang.slug ? "/" : `/${lang.slug}/`;
          let url = "";

          if (
            localeData.avaiableLangs.some(
              (avaiableLang) => avaiableLang === lang.slug
            )
          ) {
            url = `${locale}`;

            if (localeData.pageNumber > 0) {
              url += `/${localeData.pageNumber + 1}/`;
            }
          } else {
            url = `${locale}`;
          }

          return (
            <li key={lang.id} id={lang.slug}>
              <Link to={url}>
                <span className="flag">
                  {isBrowser() && (
                    <Suspense fallback="...">
                      <lang.icon width="16px" />
                    </Suspense>
                  )}
                </span>
                <span>{lang.name}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LanguageSwitcher;
